module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "gra2pes--dataset-cover.9c510604.png";